import React from "react";
import {
  Document,
  Page,
  StyleSheet
} from "@react-pdf/renderer";
import Cover from "../../Components/GeneratePdf/Cover";
import LeadershipPage1 from "../../Components/GeneratePdf/Leadership/LeadershipPage1";
import LeadershipPage2 from "../../Components/GeneratePdf/Leadership/LeadershipPage2";
import LeadershipPage3 from "../../Components/GeneratePdf/Leadership/LeadershipPage3";
import MindSetPage2 from "../../Components/GeneratePdf/MindSetPage2";
import MindSetPage3 from "../../Components/GeneratePdf/MindSetPage3";
import AccToPageHeading from "../../Components/GeneratePdf/AccToPageHeading";
import HeartPage from "../../Components/GeneratePdf/HeartPage";
import RelectAndIntegrate1 from "../../Components/GeneratePdf/RelectAndIntegrate/RelectAndIntegrate1";
import RelectAndIntegrate2 from "../../Components/GeneratePdf/RelectAndIntegrate/RelectAndIntegrate2";
import LifeIntegration1 from "../../Components/GeneratePdf/LifeIntegration/LifeIntegration1";
import LifeIntegration2 from "../../Components/GeneratePdf/LifeIntegration/LifeIntegration2";
import SoulPage from "../../Components/GeneratePdf/SoulPage";
import MindPage from "../../Components/GeneratePdf/MindPage";
import StrengthPage from "../../Components/GeneratePdf/StrengthPage";
import TableContent from "../../Components/GeneratePdf/SelfReport/TableContent";
import Overview from "../../Components/GeneratePdf/SelfReport/Overview";
import AboutReport from "../../Components/GeneratePdf/SelfReport/AboutReport";
import HomeFirst from "../../Components/GeneratePdf/SelfReport/HomeFirst";
import FourQuadrants from "../../Components/AssessmentDetail/Reports/report-pdf/FourQuadrants";
import FourQuadrantPage from "../../Components/GeneratePdf/SelfReport/FourQuadrantPage";
import StarterQuadrantChart from "../../Components/GeneratePdf/SelfReport/StarterQuadrantChart";
import HeartStarter from "../../Components/GeneratePdf/SelfReport/HeartStarter";
import QuadrantFlowHome from "../../Components/GeneratePdf/SelfReport/QuadrantFlowHome";
import QuadrantFlowPage1 from "../../Components/GeneratePdf/SelfReport/QuadrantFlowPage1";
import QuadrantFlowPage2 from "../../Components/GeneratePdf/SelfReport/QuadrantFlowPage2";
import LeadershipPage4 from "../../Components/GeneratePdf/SelfReport/LeadershipPage4";
import LeadershipFlow from '../../Components/GeneratePdf/Leadership/LeadershipFlow';
import LeaderFlowDetails from '../../Components/GeneratePdf/Leadership/LeaderFlowDetails';
import LeaderItemsOverview from '../../Components/GeneratePdf/Leadership/LeaderItemsOverview';
import LeadItemTwoOverview from '../../Components/GeneratePdf/Leadership/LeadItemOverviewTwo';
import CollaborativePage from '../../Components/GeneratePdf/Leadership/CollaborativePage';
import VisionaryPage from '../../Components/GeneratePdf/Leadership/VisionaryPage';
import StrategicPage from '../../Components/GeneratePdf/Leadership/StrategicPage';
import PerformancePage from '../../Components/GeneratePdf/Leadership/PerformancePage';
import LifeIntegration3 from "../../Components/GeneratePdf/SelfReport/LifeIntegration3";
import LeaderPageDetails from "../../Components/GeneratePdf/Leadership/LeaderFlowDetails";
import GapAnalysisPage from "../../Components/GeneratePdf/Leadership/GapAnalysisPage";
import GapAnalysisPageTwo from "../../Components/GeneratePdf/Leadership/GapAnalysisPageTwo";
import AccToPageHeadingTwo from "../../Components/GeneratePdf/SelfReport/AccToPageHeadingTwo";
import LeadershipStyleCollaborative360 from "../../Components/Report360/LeadershipStyleCollaborative360";
import Mindset from "../../Components/AssessmentDetail/Reports/report-pdf/Mindset";
import HomeMinset from "../../Components/GeneratePdf/SelfReport/HomeMinset";
import MindSetPage from "../../Components/GeneratePdf/MindSetPage";
import MindsetImagePage from "../../Components/GeneratePdf/SelfReport/MindsetImagePage";
import { calculatePageNumbers } from "../../utils/helper";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 30,
  },
  page2: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 20,
  },
  pagespace: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: 21,
    height: 792,
    justifyContent: "space-between",
  },
});

// Updated pageComponentMap to match new menu structure
const pageComponentMap = {
  "Cover Page": [
    { component: Cover, style: styles.page }
  ],
  "Table of Contents": [
    { component: (props) => <TableContent {...props} pageNumbers={calculatePageNumbers(props.menuItems, pageComponentMap)} />, style: styles.page }
  ],
  "Overview": [
    { component: Overview, style: styles.page }
  ],
  "Summary Snapshot": [
    { component: AboutReport, style: styles.page }
  ],
  "Starter Quadrant": [
    { component: HomeFirst, style: styles.page }
  ],       
  "Four Quadrants": [
    { component: FourQuadrantPage, style: styles.page }
  ],
  "Starter Quadrant Chart": [
    { component: StarterQuadrantChart, style: styles.page }
  ],
  "Results": [
    { component: HeartStarter, style: styles.page }
  ],
  "HomeQuadrantFlow": [
    { component: QuadrantFlowHome, style: styles.page }
  ],
  "Introduction": [
    { component: QuadrantFlowPage1, style: styles.page },
  ],
  "Quadrant Flow": [
    { component: QuadrantFlowPage2, style: styles.page }
  ],
  "QFItemOnePage": [
    { component: AccToPageHeading, style: styles.page2 },
    { component: AccToPageHeadingTwo, style: styles.page2 }
  ],
  "Heart": [
    { component: HeartPage, style: styles.page2 }
  ],
  "Soul": [
    { component: SoulPage, style: styles.page2 }
  ],
  "Mind": [
    { component: MindPage, style: styles.page2 }
  ],
  "Strength": [
    { component: StrengthPage, style: styles.page2 }
  ],
  // Leadership Style
  "Home Leadership Style": [
    { component: LeadershipPage1, style: styles.pagespace }
  ],
  "Leadership Style Introduction": [
    { component: LeadershipPage2, style: styles.pagespace }
  ],
  "Leadership Style Chart": [
    { component: LeadershipPage3, style: styles.pagespace }
  ],
  "Leadership Style Results": [
    { component: LeadershipStyleCollaborative360, style: styles.pagespace }
  ],
  // Leadership Flow Introduction
  "Leadership Flow Introduction": [
    { component: LeadershipFlow, style: styles.pagespace }
  ],
  "Leadership Flow Results": [
    { component: LeaderFlowDetails, style: styles.pagespace },
  ],
  "Items Overview": [
    { component: LeaderItemsOverview, style: styles.pagespace },
    { component: LeadItemTwoOverview, style: styles.pagespace }
  ],
  "Collaborative": [
    { component: CollaborativePage, style: styles.pagespace }
  ],
  "Visionary": [
    { component: VisionaryPage, style: styles.pagespace }
  ],
  "Strategic": [
    { component: StrategicPage, style: styles.pagespace }
  ],
  "Performance": [
    { component: PerformancePage, style: styles.pagespace }
  ],
  //Alignment Flow
  "Alignment": [
    { component: GapAnalysisPage, style: styles.page2 },
    { component: GapAnalysisPageTwo, style: styles.page2 }
  ],
  //Mindset
  "Home Mindset": [
    { component: HomeMinset, style: styles.page }
  ],
  "Mindset Introduction": [
    { component: MindSetPage, style: styles.page2 },
    { component: MindsetImagePage, style: styles.page2 }
  ],
  "Mindset Results": [
    { component: MindSetPage3, style: styles.page2 }
  ],
  //Reflect and Integrate
  "Home Reflect And Integrate": [
    { component: RelectAndIntegrate1, style: styles.page2 }
  ],
  "Reflect and Integrate": [
    { component: RelectAndIntegrate2, style: styles.page2 }
  ],
  "Life Integration": [
    { component: LifeIntegration1, style: styles.page2 }
  ],
  "Leadership Integration": [
    { component: LifeIntegration3, style: styles.page2 }
  ],
  "Final Thoughts": [
    { component: LifeIntegration2, style: styles.page2 }
  ]
};

export default function MyDocumentSelf({ apiData, menuItems, isClicked }) {

  const findActiveMenuItems = (items) => {
    const activeItems = new Set();
    const processedItems = new Set(); 
    
    const processItem = (item) => {
      if (processedItems.has(item.key)) {
        return;
      }
      
      processedItems.add(item.key);

      if (item.isActive) {
        activeItems.add(item.key);
        
        if (item.subMenu) {
          item.subMenu.forEach(subItem => {
            if (!processedItems.has(subItem.key)) {
              activeItems.add(subItem.key);
              processItem(subItem);
            }
          });
        }
      } 
      else if (item.subMenu) {
        item.subMenu.forEach(subItem => processItem(subItem));
      }
    };

    items?.forEach(item => processItem(item));
    return Array.from(activeItems);
  };

  const renderPage = (key, config, index) => {
    try {
      const Component = config.component;
      return (
        <Page 
          key={`${key}-${index}`} 
          size={{ width: 612, height: 792 }} 
          style={config.style}
        >
          <Component apiData={apiData} isClicked={isClicked} menuItems={menuItems} />
        </Page>
      );
    } catch (error) {
      console.error(`Error rendering page ${key}:`, error);
      return null;
    }
  };
  const renderedPages = new Set();
  const pages = [
    <Page key="cover" size={{ width: 612, height: 792 }} style={styles.page}>
      <Cover apiData={apiData} />
    </Page>
  ];

  const activeMenuKeys = findActiveMenuItems(menuItems || []);

  
  activeMenuKeys.forEach(key => {
    const pageConfigs = pageComponentMap[key];
    
    if (pageConfigs) {
      pageConfigs.forEach((config, index) => {
        const pageKey = `${key}-${config.component.name}`;
        if (!renderedPages.has(pageKey)) {
          const page = renderPage(key, config, index);
          if (page) {
            pages.push(page);
            renderedPages.add(pageKey);
          }
        }
      });
    }
  });

  return (
    <Document>
      {pages}
    </Document>
  );
}